import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';

import Box from '@mui/material/Box';

import { Header } from '@src/layout';

export const Route = createFileRoute('/app')({
  beforeLoad: async ({ context, location }) => {
    const { auth } = context;
    try {
      await auth.verifyToken();
    }
    catch {
      try {
        await auth.refreshToken();
      }
      catch {
        throw redirect({
          to: '/auth/login',
          search: {
            redirect: encodeURIComponent(location.href),
          },
        });
      }
    }
  },
  component: App,
});

const StyleSheet = {
  root: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh',
  },
  main: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    py: 6,
  },
};

function Root(props) {
  return <Box {...props} sx={StyleSheet.root} />;
}

import { useLocation, useNavigate } from '@tanstack/react-router';

function Navigation() {
  const navigate = useNavigate();
  const location = useLocation();
  const currentPage = location.pathname === '/' ? '/' : undefined;
  return (
    <Box component="nav">
      <Header currentPage={currentPage} onNavigate={(to) => navigate({ to })} />
    </Box>
  );
}

function Main(props) {
  return <Box {...props} component="main" sx={StyleSheet.main} />;
}

function App() {
  return (
    <Root>
      <Navigation />

      <Main>
        <Outlet />
      </Main>
    </Root>
  );
}
